export const CHANNEL = process.env['NEXT_PUBLIC_CHANNEL_NAME'] ?? process.env['CHANNEL_NAME'] ?? '';

/**
 * Const values used in the BOSS API to determine if the article is for b2c or b2b
 */
export const BOSS_API_CHANNEL_NAME = CHANNEL === 'colora' ? 'WebPar' : 'BossVip';
